import axios from 'axios'

const LOCAL_URL = process.env.REACT_APP_LOCALHOST
const API_TOKEN = localStorage.getItem("api_token") || '';

export const UPDATE_PROFILE_API =  `${LOCAL_URL}/profileUpdate`
export const GET_ACCOUNT_DETAILS = `${LOCAL_URL}/getAccountDetails`
export const CREATE_OTP          = `${LOCAL_URL}/otp/createOTP`
export const VERIFY_OTP          =  `${LOCAL_URL}/otp/verifyOTP`
export const CHANGE_PASSWORD          =  `${LOCAL_URL}/changePassword`

export async function Update_Profile(
        accouont_holder_name:string,
        email_id:string,
        contact_number:string){

    const headers = {
      'Authorization': API_TOKEN
      //'Authorization': `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
    }
    return await axios.post(UPDATE_PROFILE_API,
        {
            accouont_holder_name,email_id,contact_number

        },
        {
        headers
        }
     )
      }

export async function getAccountDetails(){

  const headers = {
    'Authorization': API_TOKEN
   // Authorization: `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`,
  }
  return await axios.get(GET_ACCOUNT_DETAILS,
      { 
        headers
      }
    )
  }

  export async function createOTP_contactnumber(type:string,contact_data:string){
    const headers ={

      'Authorization': API_TOKEN
      //Authorization:`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
    }

    return await axios.post(CREATE_OTP,
      {
        type,
        contact_data
      },
      {
        headers
      })
  }

  export async function createOTP_email(type:string,contact_data:string){
    const headers ={

      'Authorization': API_TOKEN
      //Authorization:`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
    }

    return await axios.post(CREATE_OTP,
      {
        type,
        contact_data
      },
      {
        headers
      })
  }

  export async function verify_contactnumber(type:string,otp:number,contact_data:string){
    const headers ={

      //'Authorization': API_TOKEN
      Authorization:`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
    }
     return await axios.post(VERIFY_OTP,
      {
        type,
        otp,
        contact_data
      },
      {
        headers
      })
  }

  export async function  verify_email(type:string,otp:number,contact_data:string){
    const headers ={

      'Authorization': API_TOKEN
      //Authorization:`eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY291bnRfaWQiOjF9.vQulc2UJUYmHkVDdIxiqFGiIgtv82WGun4CRzzNbzXo`
    }
     return await axios.post(VERIFY_OTP,
      {
        type,
        otp,
        contact_data
      },
      {
        headers
      })
  }

export async function change_password(old_password:string, new_password:string){
  return await axios.post(CHANGE_PASSWORD, {
    old_password,
    new_password
  })
}
  
